export default __webpack_public_path__ + "static/ingress-2-91c828cebe383f7ef90ad25c79ce6ce0.png";